import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.25C14.3935 2.24926 16.7838 2.42337 19.1519 2.77095C21.1302 3.06196 22.5 4.79409 22.5 6.741V12.759C22.5 14.7059 21.1305 16.438 19.1521 16.729C18.0675 16.8885 16.9707 17.0124 15.864 17.0997L15.8628 17.0998C15.6203 17.1185 15.4049 17.2448 15.276 17.438L12.624 21.416C12.4849 21.6247 12.2508 21.75 12 21.75C11.7492 21.75 11.5151 21.6247 11.376 21.416L8.72396 17.438C8.59526 17.245 8.37965 17.1182 8.13616 17.0987C7.02917 17.0124 5.93241 16.8885 4.84792 16.729C2.8696 16.438 1.5 14.7049 1.5 12.76V6.741C1.5 4.79523 2.8694 3.06201 4.84785 2.77099C7.18279 2.4277 9.57146 2.25001 12 2.25ZM18.9339 4.25502C16.638 3.91806 14.3207 3.74927 12.0002 3.75C9.64488 3.75 7.32912 3.92232 5.06615 4.25502C3.87663 4.43002 3 5.48479 3 6.741V12.76C3 14.0151 3.87647 15.07 5.06615 15.245C6.11746 15.3995 7.1805 15.5196 8.25331 15.6033L8.25436 15.6034C8.94266 15.658 9.58083 16.0192 9.97204 16.606L12 19.6479L14.028 16.606C14.419 16.0194 15.0573 15.6577 15.7466 15.6043C16.8197 15.5196 17.8827 15.3995 18.9339 15.245C20.1235 15.07 21 14.0161 21 12.759V6.741C21 5.484 20.1234 4.43012 18.9339 4.25502Z"
        fill={colorValue}
      />
    </svg>
  );
};
